import PropTypes from 'prop-types';
import WishCard from './WishCard';

/**
 * 送出成功結果 Popup — 顯示卡片預覽，確認後關閉並讓卡片飛入樹上固定點位
 */
const WishResultModal = ({ wish, onConfirm, cardRef }) => {
    return (
        <div className="fixed inset-0 z-500 flex flex-col items-center justify-center p-4" style={{ backgroundColor: 'rgba(0,0,0,0.65)' }}>
            <h2 className="text-xl font-bold text-white mb-1">發願已送出</h2>
            <p className="text-sm text-white/70 mb-6">您的心願即將掛上願心樹</p>

            <WishCard wish={wish} size="full" className="shadow-2xl" ref={cardRef} />

            <button
                onClick={onConfirm}
                className="mt-8 px-10 py-3 rounded-full font-semibold text-white"
                style={{ background: 'linear-gradient(135deg, #C9942B, #A8721E)' }}
            >
                掛上願心樹
            </button>
        </div>
    );
};

WishResultModal.propTypes = {
    wish: PropTypes.object.isRequired,
    onConfirm: PropTypes.func.isRequired,
    cardRef: PropTypes.object,
};

export default WishResultModal;
